import { useParams } from 'react-router-dom';
import {
    Button, Center, Text, VStack,
} from '@chakra-ui/react';
import { AppLoader } from '../../../components/app-loader';
import { DiLogo } from '../../../components/di-logo';
import { useViewOnlineQuote } from '../hooks/use-view-online-quote';

function ErrorScreen({ errorMessage }: { errorMessage: string }) {
    return (
        <Center w="100%" h="100vh">
            <VStack spacing={10}>
                <DiLogo variant="horizontalRGB" w="xs" />
                <VStack>
                    <Text fontSize="lg" fontWeight="medium" color="danger.500">
                        Unable to open quote
                    </Text>
                    <Text>{errorMessage}</Text>
                </VStack>
                <Button
                    onClick={() => window.close()}
                    variant="rounded-solid"
                    size="cta-md"
                    colorScheme="primary"
                >
                    Close this window
                </Button>
            </VStack>
        </Center>
    );
}

function ViewOnlineQuotePage({ quoteId }: { quoteId: number }) {
    // Redirects internally on success - only the error state matters here.
    const { isError, error } = useViewOnlineQuote(quoteId);

    if (isError) {
        const errorMessage = error !== undefined
            ? error.message
            : 'Please try again, or contact support if this continues.';

        return <ErrorScreen errorMessage={errorMessage} />;
    }

    return <AppLoader loadingText="Opening your quote" />;
}

export function ViewOnlineQuote() {
    const { quoteId } = useParams();
    const parsedQuoteId = Number(quoteId);

    const isValid = quoteId !== undefined
        && Number.isInteger(parsedQuoteId)
        && parsedQuoteId > 0;

    if (!isValid) {
        return <ErrorScreen errorMessage="This quote link is invalid." />;
    }

    return <ViewOnlineQuotePage quoteId={parsedQuoteId} />;
}
